module.exports = __webpack_public_path__ + "static/media/BiPartingInDark.640a685b.svg";